import { useEffect, useState } from "react";

type VisibilityState = "visible" | "hidden";

export function useTabVisibility(): VisibilityState {
  const [visibility, setVisibility] = useState<VisibilityState>("visible");

  useEffect(() => {
    const listener = function () {
      if (document.visibilityState === "visible") {
        setVisibility("visible");
      } else {
        setVisibility("hidden");
      }
    };

    document.addEventListener("visibilitychange", listener);

    return () => {
      document.removeEventListener("visibilitychange", listener);
    };
  }, []);

  return visibility;
}

export function useTabBackInFocus(callback: () => void, dependencies: Array<unknown>) {
  useEffect(() => {
    const listener = () => {
      if (document.visibilityState === "visible") {
        callback();
      }
    };

    document.addEventListener("visibilitychange", listener);

    return () => {
      document.removeEventListener("visibilitychange", listener);
    };
  }, dependencies);
}
